module.exports = __webpack_public_path__ + "img/xbzp1.ef96763e.png";